import FrequentlyBoughtTogether from 'components/ProductPage/FrequentlyBoughtTogether/FrequentlyBoughtTogether';

export default FrequentlyBoughtTogether;
